/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvancedShippingNotes } from '../../models/advanced-shipping-notes';
import { KeyType } from '../../models/key-type';

export interface PutAdvancedShippingNotes$Params {
  organizationSiteKey: KeyType;
      body: AdvancedShippingNotes
}

export function putAdvancedShippingNotes(http: HttpClient, rootUrl: string, params: PutAdvancedShippingNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putAdvancedShippingNotes.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putAdvancedShippingNotes.PATH = '/organizationSites/{organizationSiteKey}/consignee/advancedShippingNotes';
